import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage, base64ToFile } from 'ngx-image-cropper';

@Component({
    selector: 'app-image-cropper-modal',
    templateUrl: './image-cropper-modal.component.html',
    styleUrls: ['./image-cropper-modal.component.scss']
})
export class ImageCropperModalComponent {
    imageChangedEvent: any = '';
    croppedImage: any = '';
    blob: any = null;
    @Input() imageFile: any;
    @Input() aspect: number = 1;
    @Input() roundCropper: boolean = false;
    @Input() fileName: string = '';

    @Output() closeEvent = new EventEmitter<any>();
    @Output() completeCrop = new EventEmitter<any>();

    constructor(private sanitizer: DomSanitizer) {

    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64 as string;
        this.blob = this.dataURLtoFile(event.base64, this.fileName);

    }
    imageLoaded(image: LoadedImage) {
    }
    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        // show message
    }

    doCrop() {
        this.completeCrop.emit({
            data: this.blob,
            base64: this.croppedImage
        });
    }

    //https://stackoverflow.com/questions/35940290/how-to-convert-base64-string-to-javascript-file-object-like-as-from-file-input-f
    dataURLtoFile(dataurl: any, filename: any) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }


    close() {
        this.closeEvent.emit('');
    }
}
